import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpPopoutComponent } from './components/help-popout/help-popout.component';
import { RouterModule } from '@angular/router';
import { SubjectTopicLinkButtonComponent } from './components/subject-topic-link-button/subject-topic-link-button.component';
import { MonoCommonModule } from '@nx/mono-common';
import { SecondaryPageCtaPanelComponent } from './components/secondary-page-cta-panel/secondary-page-cta-panel.component';



@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    HelpPopoutComponent,
    SubjectTopicLinkButtonComponent,
    SecondaryPageCtaPanelComponent,
  ],
  exports: [
    HelpPopoutComponent,
    SubjectTopicLinkButtonComponent,
    MonoCommonModule,
    SecondaryPageCtaPanelComponent
  ]
})
export class LmwCommonModule {

}
